export const UserProjectRoleTranslationInjection: { name: string; value: string }[] = [];
